import type {
	CompanyProvider, DriveItem, Integration, IntegrationName, IntegrationProvider, IntegrationScopeTypes
} from '@types'
import axios from 'axios'

import env from '../environments'

export async function initIntegration(provider: IntegrationProvider, integrationName: IntegrationName, brainId: string) {
	const response = await axios.post(`${env.apiUrl}/integrations/${provider}/init`, { brainId, integrationName })

	return response.data as {url: string}
}

export async function getBrainIntegrations(brainId: string, mine: boolean) {
	const response = (await axios.get(`${env.apiUrl}/integrations/brain/${brainId}/${mine ? 'true' : 'false'}`))

	return response.data as Integration[]
}

export async function getCompanyIntegrations(companyId: string) {
	const response = (await axios.get(`${env.apiUrl}/integrations/company/${companyId}`))

	return response.data as CompanyProvider[]
}

export async function getIntegration(integrationId: string) {
	const response = (await axios.get(`${env.apiUrl}/integrations/${integrationId}`))

	return response.data as {integration: Integration; selectedContentsAmount: number}
}

export async function updateIntegration(integration: Partial<Integration> & {id: string}) {
	const response = (await axios.put(`${env.apiUrl}/integrations/${integration.id}`, integration))

	return response.data as Integration
}

export async function forceUpdateIntegration(integration: Partial<Integration> & {id: string}) {
	await axios.post(`${env.apiUrl}/integrations/${integration.id}/update`)
}

export async function getIntegratedItems(integrationId: string) {
	const response = await axios.get(`${env.apiUrl}/integrations/${integrationId}/integratedItems`)

	return response.data as DriveItem[]
}

export async function browseFiles(integrationId: string, scopeType: IntegrationScopeTypes, folder?: string | undefined, driveId?: string | undefined) {
	const response = (await axios.get(`${env.apiUrl}/integrations/${integrationId}/browse`, {
		params: {
			scopeType,
			folder,
			driveId
		}
	}))

	return response.data as DriveItem[]
}

export async function searchDrives(integrationId: string, scopeType: IntegrationScopeTypes, query: string) {
	const response = await axios.post(`${env.apiUrl}/integrations/${integrationId}/search`, { scopeType, query })

	return response.data as DriveItem[]
}

export async function updateIntegrationContents(
	integrationId: string,
	itemsToAdd: DriveItem[],
	itemsToRemove: DriveItem[],
	itemsToUnselect: DriveItem[],
	scopeType: IntegrationScopeTypes
) {
	return axios.post(
		`${env.apiUrl}/integrations/${integrationId}/contents`,
		{
			itemsToAdd, itemsToRemove, itemsToUnselect, scopeType
		}
	)
}
